import { inject, Injectable } from '@angular/core';
import { map, Observable, of } from 'rxjs';
import { SupabaseService } from '../supabase/supabase';
import { doSupabaseCall } from '../../shared/helpers/supabase.helper';

const BUCKET = 'tavole-immagini';

// Immagini del questionario (card D8, tavole D9) nel bucket pubblico BUCKET: upload e URL.
// La tabella app_tavole (storico delle tre tavole fisse) non si legge né si scrive più: dallo
// step 6 le tavole sono sottodomande visive di question_app / question_image_app.
@Injectable({ providedIn: 'root' })
export class TavoleService {
  // --- private ---
  private readonly _supabase: SupabaseService = inject(SupabaseService);

  // --- public ---
  // Upload: path {categoriaSlug}/{uuid}.{ext}, MAI sovrascritto (niente upsert) → ogni path resta
  // valido per sempre. Restituisce il PATH nel bucket, che va in question_image_app.image_path.
  public uploadPath(file: File, categoriaSlug: string): Observable<string> {
    const client = this._supabase.client;
    if (null === client) {
      return of('');
    }
    const ext = file.name.includes('.') ? file.name.split('.').pop() : 'jpg';
    const path = `${categoriaSlug}/${crypto.randomUUID()}.${ext}`;
    return doSupabaseCall(
      client.storage.from(BUCKET).upload(path, file, { contentType: file.type }),
    ).pipe(map(() => path));
  }

  // Path nel bucket → URL pubblico. Un valore già assoluto (URL) o relativo (/…) passa tal quale.
  public publicUrl(path: string): string {
    const client = this._supabase.client;
    if (null === client || '' === path || path.startsWith('/') || path.startsWith('http')) {
      return path;
    }
    return client.storage.from(BUCKET).getPublicUrl(path).data.publicUrl;
  }
}
